<app-confirm-delete-alert #confirmdocument></app-confirm-delete-alert>
<app-confirm-delete-alert #choosedocument></app-confirm-delete-alert>
<app-confirm-delete-alert #confirmcontact></app-confirm-delete-alert>
<app-confirm-delete-alert #confirmdeleteask></app-confirm-delete-alert>

<!-- =========================================================
= AUTO FIELD BUILD — floating labels + annotations by Field.Type
= Règles:
=  - Tous les inputs/textarea utilisent [label] + labelPlacement="floating"
=  - Suppression des ion-list wrappers qui empêchent le label de flotter
=  - Annotations par bloc: TYPE == '...'
========================================================= -->

<ion-grid *ngIf="Structure.length>0"
  class="card {{!Structure.length ? 'disabled' : 'position-relative'}} {{showModifMessage ? 'no-padding-bottom' : ''}}"
  style="padding-top: 1.25rem;">

  <ion-row *ngIf="CurrentAsk?.GmaoRef>0">
    <ion-col>
      <ion-text style="width: 100%; text-align: right;color:var(--ion-color-secondary);font-weight: bold;"
        class="ion-float-right">
        {{manager.Trad.Parse("STR_EXTERNAL_REFERENCE",{Ref: CurrentAsk?.GmaoRef })}}
      </ion-text>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="CurrentAsk?.IsFake">
    <ion-col>

      <!-- ===== STATIC TARGET EMAIL (fake ask header) ===== -->
      <ion-item lines="none"
        style="width: fit-content; --padding-start: 0; --padding-end: 0; --margin-start: 0; --margin-end: 0; margin: 0; padding: 0;">
        <ion-label class="" style="max-width: 100%;margin-bottom:0;margin-top:0;font-weight: bold">
          {{manager.Trad.Parse("STR_TARGET_EMAIL")}}
        </ion-label>
        <ion-button (click)="this.CreaPage?.resetAsk()" fill="clear" size="default"
          style="min-height: auto;min-width: auto; margin-left: 8px; ">
          <ion-icon name="pencil" slot="icon-only" style="font-size: 22px;"></ion-icon>
        </ion-button>
      </ion-item>

      <!-- Valeur email (readonly) -->
      <ion-input *ngIf="!CreaPage?.isSkipMail" [(ngModel)]="targetEmail" readonly="true" style="pointer-events: none;"
        [label]="manager.Trad.Parse('STR_TARGET_EMAIL')" labelPlacement="floating">
      </ion-input>

      <ion-input *ngIf="CreaPage?.isSkipMail" [value]="manager.Trad.Parse('STR_TO_COMPLETE')" readonly="true"
        style="pointer-events: none;" lines="none" [label]="manager.Trad.Parse('STR_TARGET_EMAIL')"
        labelPlacement="floating">
      </ion-input>
      <!-- ===== END STATIC TARGET EMAIL ===== -->

    </ion-col>
  </ion-row>

  <ion-row *ngFor="let Field of Structure">

    <!-- ===== TYPE: input (Field.Type == 'input') ===== -->
    <ion-col *ngIf="Field.isActive() && Field.Type == 'input'" class="position-relative">
      <ion-item [disabled]="!Field.CanEdit"
        [style.--border-color]="Field.CanEdit && Field.limitSize>0 && ((Field.Value?.length || 0) >= (Field.limitSize - 5)) ? 'var(--ion-color-danger)' : null"
        style="--border-width: 0 0 2px 0; {{Field.IsImposedAndNotFilled ? 'margin-bottom: 2rem' :'' }}">
        <ion-input [readonly]="!Field.CanEdit" [(ngModel)]="Field.Value" class="font-weight-semi-bold"
          [label]="Field.Label" labelPlacement="floating" [maxlength]="Field.limitSize > 0 ? Field.limitSize : null">
        </ion-input>
      </ion-item>
      <ion-note *ngIf="Field.IsImposedAndNotFilled" color="danger" class="note-position"
        style="margin-bottom: 0.8rem">{{manager.Trad.Parse("STR_IMPOSED_FIELD")}}</ion-note>
    </ion-col>
    <!-- ===== END TYPE: input ===== -->

    <!-- ===== TYPE: phonenumber (Field.Type == 'phonenumber') ===== -->
    <ion-col *ngIf="Field.isActive() && Field.Type == 'phonenumber'" class="position-relative">

      <!-- Variante OwnerPhoneNumber -->
      <ion-item [disabled]="!Field.CanEdit" *ngIf="Field.TargetField == 'OwnerPhoneNumber'"
        [style.--border-color]="Field.CanEdit && Field.limitSize>0 && ((Field.Value?.length || 0) >= (Field.limitSize - 5)) ? 'var(--ion-color-danger)' : null">
        <ion-input inputmode="tel" [readonly]="!Field.CanEdit" [(ngModel)]="Field.Value" [label]="Field.Label"
          labelPlacement="floating" [maxlength]="Field.limitSize > 0 ? Field.limitSize : null">
        </ion-input>
      </ion-item>

      <!-- Variante générique -->
      <ion-item [disabled]="!Field.CanEdit" *ngIf="Field.TargetField != 'OwnerPhoneNumber'"
        [style.--border-color]="Field.CanEdit && Field.limitSize>0 && ((Field.Value?.length || 0) >= (Field.limitSize - 5)) ? 'var(--ion-color-danger)' : null"
        style="{{Field.IsImposedAndNotFilled ? 'margin-bottom: 2rem' :'' }}">
        <ion-input inputmode="tel" [readonly]="!Field.CanEdit" [(ngModel)]="Field.Value" [label]="Field.Label"
          labelPlacement="floating" [maxlength]="Field.limitSize > 0 ? Field.limitSize : null">
        </ion-input>
      </ion-item>

      <ion-note *ngIf="Field.IsImposedAndNotFilled" color="danger" style="margin-bottom: 0.8rem;"
        class="note-position">{{manager.Trad.Parse("STR_IMPOSED_FIELD")}}</ion-note>
    </ion-col>
    <!-- ===== END TYPE: phonenumber ===== -->

    <!-- ===== TYPE: textarea (Field.Type == 'textarea') ===== -->
    <ion-col *ngIf="Field.isActive() && Field.Type == 'textarea' && (Field.Value || Field.CanEdit)"
      class="position-relative">
      <ion-item [disabled]="!Field.CanEdit"
        [style.--border-color]="Field.CanEdit && Field.limitSize>0 && ((Field.Value?.length || 0) >= (Field.limitSize - 5)) ? 'var(--ion-color-danger)' : null"
        [style.--border-width]="Field.CanEdit && Field.limitSize>0 && ((Field.Value?.length || 0) >= (Field.limitSize - 5)) ? '0 0 2px 0' : '0px'"
        style="--border-width: 0px; {{Field.IsImposedAndNotFilled ? 'margin-bottom: 2rem' :'' }}" lines="none">
        <ion-textarea [readonly]="!Field.CanEdit" [autoGrow]="true" [(ngModel)]="Field.Value" [label]="Field.Label"
          labelPlacement="floating" [maxlength]="Field.limitSize > 0 ? Field.limitSize : null">
        </ion-textarea>
      </ion-item>
      <ion-note *ngIf="Field.IsImposedAndNotFilled" color="danger" style="margin-bottom: 0.8rem;"
        class="note-position">{{manager.Trad.Parse("STR_IMPOSED_FIELD")}}</ion-note>
    </ion-col>
    <!-- ===== END TYPE: textarea ===== -->

    <!-- ===== TYPE: boolean (Field.Type == 'boolean') ===== -->
    <ion-col *ngIf="Field.isActive() && Field.Type == 'boolean'" class="position-relative">
      <ion-item [disabled]="!Field.CanEdit" lines="none"
        style="{{Field.IsImposedAndNotFilled ? 'margin-bottom: 2rem' :'' }}">
        <ion-label style="max-width: 100%;" class="ion-text-wrap">{{Field.Label}}</ion-label>
        <ion-toggle slot="end" [(ngModel)]="Field.Value"></ion-toggle>
      </ion-item>
      <ion-note *ngIf="Field.IsImposedAndNotFilled" color="danger" style="margin-bottom: 0.8rem;"
        class="note-position">{{manager.Trad.Parse("STR_IMPOSED_FIELD")}}</ion-note>
    </ion-col>
    <!-- ===== END TYPE: boolean ===== -->

    <!-- ===== TYPE: geolocation (Field.Type == 'geolocation') ===== -->
    <ion-col *ngIf="Field.isActive() && Field.Type == 'geolocation'">
      <ion-item lines="none" style="{{Field.IsImposedAndNotFilled ? 'margin-bottom: 2rem' :'' }}">
        <!-- (ion-list supprimé) -->
        <div [id]="Field.DivId" class="geofield"></div>
      </ion-item>
      <ion-note *ngIf="Field.IsImposedAndNotFilled" color="danger" style=" margin-bottom: 0.8rem;"
        class="note-position">{{manager.Trad.Parse("STR_IMPOSED_FIELD")}}</ion-note>
    </ion-col>
    <!-- ===== END TYPE: geolocation ===== -->

    <!-- ===== TYPE: selector (Field.Type == 'selector') ===== -->
    <ion-col *ngIf="Field.isActive() && Field.Type == 'selector'" class="position-relative">

      <!-- Sélecteur d'état -->
      <ion-item [disabled]="!Field.CanEdit" (click)="Field.onClick()" *ngIf="Field.TargetField == 'State'" lines="none"
        style="{{Field.IsImposedAndNotFilled ? 'margin-bottom: 2rem' :'' }}">
        <div class="state-selector">
          <ion-label>{{Field.Label}}</ion-label>
          <div class="back-state-{{Field.StateNumber}}"
            style="border-radius: 50%; height: 1.25rem; width: 1.25rem; margin-right: 8px"></div>
          <ion-text class="ion-text-wrap color-state-{{Field.StateNumber}} font-weight-semi-bold"
            style="font-size: 1.2rem">
            {{manager.Trad.Parse(Field.Value)}}
          </ion-text>
          <ion-icon name="chevron-down-outline" slot="end" size="large"></ion-icon>
        </div>
      </ion-item>

      <!-- Autres sélecteurs - vide -->
      <ion-item (click)="Field.onClick()" [disabled]="!Field.CanEdit"
        style="{{Field.IsImposedAndNotFilled ? 'margin-bottom: 2rem' :'' }}"
        *ngIf="(!Field.TargetField || Field.TargetField != 'State') && !Field.Value">
        <ion-label style="max-width: 100%;">{{Field.Label}}</ion-label>
        <ion-icon name="chevron-down-outline" slot="end" size="large" style="align-self: flex-end"></ion-icon>
      </ion-item>

      <!-- Autres sélecteurs - valeur présente -->
      <ion-item (click)="Field.onClick()" [disabled]="!Field.CanEdit"
        style="{{Field.IsImposedAndNotFilled ? 'margin-bottom: 2rem' :'' }}"
        *ngIf="(!Field.TargetField || Field.TargetField != 'State') && Field.Value">
        <ion-label style="max-width: 100%;" position="stacked" style="font-size: 16px">{{Field.Label}}</ion-label>
        <ion-text class="ion-text-wrap; font-weight-semi-bold" style="font-size: 1.2rem; margin-top: .5rem">
          {{manager.Trad.Parse(Field.Value)}}
        </ion-text>
        <ion-icon name="chevron-down-outline" slot="end" size="large" style="align-self: flex-end"></ion-icon>
      </ion-item>

      <ion-note *ngIf="Field.IsImposedAndNotFilled" color="danger" style="margin-bottom: 0.8rem;"
        class="note-position">{{manager.Trad.Parse("STR_IMPOSED_FIELD")}}</ion-note>
    </ion-col>
    <!-- ===== END TYPE: selector ===== -->

    <!-- ===== TYPE: document (Field.Type == 'document') ===== -->
    <ion-col *ngIf="Field.isActive() && Field.Type == 'document'" class="position-relative">
      <input [id]="'documentsPicker'+Field.Order" #filepicker hidden type="file" (change)="Field.onEvent($event)" />
      <ion-item lines="none" style="box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2); border-radius: 1rem;">
        <ion-button [disabled]="!Field.CanEdit" (click)="Field.onClick()" fill="clear" color="primary" expand="block"
          style="height:100%;width:100%;text-transform:none; padding: .75rem .5rem;" class="ion-text-wrap">
          <ion-text class="ion-text-start" style="width: 100%; font-size: 1.2rem;">
            {{Field.Label}}
          </ion-text>
          <ion-icon name="document-attach" slot="end" size="large"></ion-icon>
        </ion-button>
      </ion-item>

      <ion-list
        style="width: 100%; height: 100%; overflow-y: auto; max-height: 250px; display: grid; grid-template-columns:repeat(3, 1fr); gap: 5px; grid-auto-rows: min-content;background: transparent;"
        *ngIf="Field.Value.length>0">
        <ion-card *ngFor="let Document of Field.Value" lines="none"
          style="max-height: 230px; margin: 0; display: flex; flex-direction: column;">

          <!-- Image preview -->
          <ion-img class="sizePicture" *ngIf="Document.canDisplayAs('img')" [src]="Document.PictureSrc"
            (click)="Document.viewDocument()">
          </ion-img>

          <!-- Document icon (non-image) -->
          <app-doctype style="margin: 0 auto;" *ngIf="!Document.canDisplayAs('img')" [filenameOrExt]="Document.FileName"
            [size]="80" class="doc-icon-click" (click)="Document.viewDocument()">
          </app-doctype>

          <ion-card-content
            style="padding-inline-start: 4px; padding-inline-end: 4px; padding-bottom: 4px; padding-top: 4px; display: flex; align-items: flex-end; justify-content: space-between;"
            [style.flex-grow]=" Document.canDisplayAs('img') ? '1' : '' ">
            <ion-text style="font-size: 12px; max-width: 80%;margin: 0 auto;">{{ Document.FileName }}</ion-text>
            <ion-icon *ngIf="Field.CanEdit" name="trash-outline" slot="end"
              (click)="Document.confirmDelete(confirmDocumentAlert)" color="primary" style="font-size: 20px;">
            </ion-icon>
          </ion-card-content>
        </ion-card>

      </ion-list>
      <ion-note *ngIf="Field.IsImposedAndNotFilled" color="danger"
        class="note-position">{{manager.Trad.Parse("STR_IMPOSED_FIELD")}}</ion-note>
    </ion-col>
    <!-- ===== END TYPE: document ===== -->

    <!-- ===== TYPE: datetime (Field.Type == 'datetime') ===== -->
    <ion-col *ngIf="Field.isActive() && Field.Type == 'datetime'" class="position-relative"
      style="{{Field.IsImposedAndNotFilled ? 'margin-bottom: 2rem' :'' }}">

      <!-- Création (readonly texte) -->
      <ion-text *ngIf="Field.TargetField == 'CreatedDate'" color="medium" style="display:block; margin-bottom: 1.5rem">
        {{Field.Label}} {{Field.HtmlValue}}
      </ion-text>

      <!-- Datetime éditable -->
      <ion-item [disabled]="!Field.CanEdit" *ngIf="Field.TargetField != 'CreatedDate'">
        <!-- Label visuel pour cohérence UI -->
        <ion-note slot="start">{{Field.Label}}</ion-note>
        <ion-datetime-button datetime="datetime_{{Field.Order}}"></ion-datetime-button>
        <ion-modal [keepContentsMounted]="true">
          <ng-template>
            <ion-datetime [readonly]="!Field.CanEdit" [(ngModel)]="Field.Date" id="datetime_{{Field.Order}}">
            </ion-datetime>
          </ng-template>
        </ion-modal>
      </ion-item>

      <ion-note *ngIf="Field.IsImposedAndNotFilled" color="danger" style=" margin-bottom: 0.8rem;"
        class="note-position">{{manager.Trad.Parse("STR_IMPOSED_FIELD")}}</ion-note>
    </ion-col>
    <!-- ===== END TYPE: datetime ===== -->

  </ion-row>

  <ion-row *ngIf="!CurrentAsk?.IsFake">
    <ion-col>
      <ion-item lines="none" (click)="SwitchInterlocutorsState($event)" style="margin-bottom: 0;">
        <ion-icon *ngIf="!interlocutorIsOpened" name="chevron-forward-outline"
          style="color: var(--ion-color-secondary) ;"></ion-icon>
        <ion-label *ngIf="!interlocutorIsOpened">{{manager.Trad.Parse("STR_INTERLOCUTORS")}}</ion-label>
        <ion-icon *ngIf="!interlocutorIsOpened" name="people" style="color: var(--ion-color-secondary) ;"></ion-icon>

        <ion-icon *ngIf="interlocutorIsOpened" name="chevron-down-outline"
          style="color: var(--ion-color-primary) ;"></ion-icon>
        <ion-label *ngIf="interlocutorIsOpened"
          style="color: var(--ion-color-primary) ;">{{manager.Trad.Parse("STR_INTERLOCUTORS")}}</ion-label>
        <ion-icon *ngIf="interlocutorIsOpened" name="people" style="color: var(--ion-color-primary) ;"></ion-icon>
      </ion-item>

      <div *ngIf=" interlocutorIsOpened" style="display: flex;flex-direction: column;">
        <ion-label *ngIf=" CurrentAsk?.isShared ||!CurrentAsk?.isOwner|| !manager.Usr.isLoged">
          {{manager.Trad.Parse("STR_RECEIVE_FROM",{Email: (CurrentAsk?.OwnerSociety? "("+CurrentAsk?.OwnerSociety+")
          ":"" )+CurrentAsk?.OwnerDisplayEmail })}}
        </ion-label>
        <ion-label *ngIf="CurrentAsk?.isShared || CurrentAsk?.isOwner || !manager.Usr.isLoged">
          {{manager.Trad.Parse("STR_SEND_TO",{Email: (CurrentAsk?.TargetSociety? "("+CurrentAsk?.TargetSociety+") ":""
          )+CurrentAsk?.TargetDisplayEmail })}}
        </ion-label>
        <app-shares #shares [CurrentAsk]="CurrentAsk" *ngIf="CurrentAsk?.CanAddShares"
          style="width: cacl(100% - 3rem); margin-left: 1.5rem;margin-right: 1.5rem;"></app-shares>
      </div>
    </ion-col>
  </ion-row>

  <ion-text *ngIf="showModifMessage"
    style="text-align: center; margin-top: 1rem; display: block; color: var(--ion-color-medium)">
    {{manager.Trad.Parse('STR_MODIFICATIONS_SAVED')}}
  </ion-text>

  <ion-button class="card-end-button" [disabled]="pandingRequest" (click)="CreaPage?.NextPhase()"
    *ngIf="Structure.length>0 && CurrentAsk?.IsFake">
    <ion-label *ngIf="!pandingRequest && !manager.Usr.isLoged">{{manager.Trad.Parse('STR_VALIDATE')}}</ion-label>
    <ion-label *ngIf="!pandingRequest && manager.Usr.isLoged">{{manager.Trad.Parse('STR_SEND')}}</ion-label>
    <div *ngIf="pandingRequest" class="loading-icon">
      <ion-icon name="refresh-outline"></ion-icon>
    </div>
  </ion-button>

  <ion-button class="card-end-button" [disabled]="pandingRequest" (click)="ValidateMail()"
    *ngIf="!CurrentAsk?.IsFake && DisplayValidateButton">
    <ion-label>{{manager.Trad.Parse('STR_VALIDATE')}}</ion-label>
    <div *ngIf="pandingRequest" class="loading-icon">
      <ion-icon name="refresh-outline"></ion-icon>
    </div>
  </ion-button>

  <ion-item *ngIf="!CurrentAsk?.IsFake && CurrentAsk.isDeletable" lines="none" class="card-end-right-button"
    color="tertiary" (click)="confirmeDeleteAsk()">
    <ion-icon name="trash" slot="start"></ion-icon>
    <ion-text>{{manager.Trad.Parse("STR_DELETE")}}</ion-text>
  </ion-item>

</ion-grid>